/* This is the EMIS private primary and secondary school fee components */

<template>
  <v-container>
    <v-row>
      <span v-html="title"></span>
    </v-row>
    <v-row>
      <table
        style="height: 61px; width: 700px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr style="height: 25px">
            <td
              style="
                height: 25px;
                width: 280px;
                text-align: center;
                vertical-align: middle;
              "
            >
              រូបិយវត្ថុ
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ colTitle[0] }}
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ colTitle[1] }}
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ colTitle[2] }}
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ colTitle[3] }}
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ colTitle[4] }}
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              {{ colTitle[5] }}
            </td>
          </tr>
          <tr style="height: 25px">
            <td style="height: 25px; width: 280px">
              ជាប្រាក់ដុល្លារក្នុងមួយនាក់
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[0]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[1]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[2]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[3]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[4]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="data[0].dt[5]" style="width: 70px" />
            </td>
          </tr>
        </tbody>
      </table>
    </v-row>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title", "colTitle"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {};
  },
};
</script>
